document.addEventListener('DOMContentLoaded', function () {
  const hosts = Array.from(document.querySelectorAll('.konzept-host'));
  if (!hosts.length) return;

  hosts.forEach(processHost);

  // Optional: Wenn Tabs/Panels Inhalte nachträglich einblenden, beobachten
  const observer = new MutationObserver((mutations) => {
    mutations.forEach(m => {
      const added = Array.from(m.addedNodes || []).filter(n => n.nodeType === 1);
      added.forEach(el => {
        // Falls neue Panels/Accordion-Contents dazukommen
        const newHosts = el.matches?.('.konzept-host') ? [el] : Array.from(el.querySelectorAll?.('.konzept-host') || []);
        newHosts.forEach(processHost);
      });
    });
  });
  observer.observe(document.body, { childList: true, subtree: true });

  function processHost(root) {
    // --- Opt-out/Kompatibilität mit alten Beschreibungen --------------------

    // A) Explizites Opt-out via Klasse (z. B. per Produkt-Tag gesetzt)
    if (root.classList.contains('konzept-skip')) return;

    // B) Opt-out per Kommentar am Anfang der Beschreibung: <!-- konzept: skip -->
    const hasSkipComment = Array.from(root.childNodes).some(
      n => n.nodeType === 8 && /konzept:\s*skip/i.test(n.nodeValue || '')
    );
    if (hasSkipComment) return;

    // C) Auto-Erkennung von Legacy-Layouts – nicht umbauen
    // Marker: vorhandene Wrapper/Inline-Styles aus alten Beschreibungen
    const legacyMarkers = [
      '.container.reverse',
      '.image-wrapper',
      '.konzept-container',        // evtl. manuell eingefügte neue Wrapper
      '#konzept',                  // alter ID-Wrapper in der Beschreibung
      'style'                      // Inline-Styles im Beschreibungs-HTML
    ];
    const isLegacy = legacyMarkers.some(sel => root.querySelector(sel));
    if (isLegacy) {
      root.classList.add('konzept-legacy'); // optional nutzbar für CSS
      return;
    }

    // --- tatsächlichen Content-Knoten ermitteln -----------------------------
    const contentHost =
      root.querySelector('.accordion__content.prose') ||
      root.querySelector('[role="tabpanel"] .prose') ||
      root.querySelector('.prose') ||
      root.querySelector('.rte') ||
      root;

    // Schon umgebaut? (nur auf diesem Knoten prüfen)
    if (contentHost.dataset.konzeptBuilt === '1' || contentHost.querySelector('.konzept-container')) return;

    const nodes = Array.from(contentHost.childNodes).filter(n => !(n.nodeType === 3 && !n.textContent.trim()));
    if (!nodes.length) return;

    const findImgInNode = (n) => {
      if (n.nodeType !== 1) return null;
      if (n.matches('img')) return n;
      return n.querySelector && n.querySelector('img') ? n.querySelector('img') : null;
    };

    // Bilder aus Headings herauslösen (Headline bleibt, Bild wird eigener Knoten)
    nodes.forEach((n) => {
      const img = findImgInNode(n);
      if (img) {
        const heading = img.closest?.('h1,h2,h3,h4,h5,h6');
        if (heading) {
          const after = document.createTextNode('');
          heading.after(after);
          after.parentNode.insertBefore(img, after);
          after.parentNode.removeChild(after);
        }
      }
    });


    const flatNodes = Array.from(contentHost.childNodes).filter(n => !(n.nodeType === 3 && !n.textContent.trim()));
    const hasImage = flatNodes.some(n => !!findImgInNode(n));

    // Wenn keine Bilder: alles in einen Text-Container packen (einspaltig)
    if (!hasImage) {
      const c = makeContainer(true);
      const t = makeText();
      flatNodes.forEach(n => t.appendChild(n.cloneNode(true)));
      c.appendChild(t);
      contentHost.innerHTML = '';
      contentHost.appendChild(c);
      contentHost.dataset.konzeptBuilt = '1';
      return;
    }

    // Jedes Bild startet einen neuen Abschnitt; sammle Text bis zum nächsten Bild
    const fragments = [];
    let i = 0;
    while (i < flatNodes.length) {
      let imgIndex = -1;
      for (let j = i; j < flatNodes.length; j++) {
        if (findImgInNode(flatNodes[j])) { imgIndex = j; break; }
      }

      if (imgIndex === -1) {
        if (fragments.length === 0) {
          fragments.push({ imgEl: null, textNodes: flatNodes.slice(i) });
        } else {
          const last = fragments[fragments.length - 1];
          last.textNodes = last.textNodes.concat(flatNodes.slice(i));
        }
        break;
      }

      const preText = flatNodes.slice(i, imgIndex).filter(Boolean);
      if (preText.length) fragments.push({ imgEl: null, textNodes: preText });

      const imgEl = findImgInNode(flatNodes[imgIndex]);
      let k = imgIndex + 1;
      const postText = [];
      for (; k < flatNodes.length; k++) {
        if (findImgInNode(flatNodes[k])) break;
        postText.push(flatNodes[k]);
      }

      fragments.push({ imgEl, textNodes: postText });
      i = k;
    }

    // Neu rendern
    contentHost.innerHTML = '';
    fragments.forEach((frag, idx) => {
      const isTextOnly = !frag.imgEl;
      const container = makeContainer(isTextOnly);
      if (!isTextOnly && idx % 2 === 1) container.classList.add('konzept-reverse');

      if (!isTextOnly) {
        const iw = document.createElement('div');
        iw.className = 'konzept-image-wrapper';
        const newImg = document.createElement('img');
        Array.from(frag.imgEl.attributes).forEach(attr => {
          if (['src','srcset','sizes','alt','width','height','loading','decoding'].includes(attr.name)) {
            newImg.setAttribute(attr.name, attr.value);
          }
        });
        if (!newImg.getAttribute('loading')) newImg.setAttribute('loading','lazy');
        iw.appendChild(newImg);
        container.appendChild(iw);
      } else {
        container.classList.add('konzept-text-only');
      }

      const text = makeText();
      frag.textNodes.forEach(n => text.appendChild(n.cloneNode(true)));
      container.appendChild(text);
      contentHost.appendChild(container);
    });

    contentHost.dataset.konzeptBuilt = '1';
  }

  function makeContainer(isTextOnly) {
    const el = document.createElement('div');
    el.className = 'konzept-container';
    if (isTextOnly) el.classList.add('konzept-text-only');
    return el;
  }
  function makeText() {
    const el = document.createElement('div');
    el.className = 'konzept-text';
    return el;
  }
});
